module.exports = __webpack_public_path__ + "static/img/02344_6.6d128a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_6.jpg
// module id = 0F1h
// module chunks = 1